<template>
  <v-dialog v-model="dialog" persistent :max-width="options.width" :style="{ zIndex: options.zIndex }"
            @keydown.esc="agree">
    <v-card :outlined="true" :raised="true">
      <v-card-title primary-title class="mb-4">
        <div>
          <h3 class="h4 mb-2">{{ title }} {{timeLeft}} seconds</h3>
          <div> {{ message }}</div>
        </div>
      </v-card-title>

      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="cancel" class="text-none">Logout</v-btn>
        <v-btn depressed color="primary darken-1" @click.native="agree" class="text-none">Stay signed in</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions, mapState} from "vuex";

  let logoutIntervalTimer;
  export default {
    name: 'idleWarning',
    data: () => ({
      dialog: false,
      message: "Your session is about to expire. Please choose to stay signed in or log out. Otherwise you will be logged out automatically.",
      title: "Your session will expire in ",
      timeLeft: '60',
      options: {
        color: 'primary',
        width: 636,
        zIndex: 200
      }
    }),
    computed: {
      ...mapState({
          school: s => s.school.selected
      }),
    },
    methods: {
      open() {
        this.dialog = true;
        this.setTime(60);
      },
      isOpened() {
        return this.dialog === true;
      },
      async agree() {
        clearInterval(logoutIntervalTimer);
        this.dialog = false;
        await this.refreshToken(this.$store.state);
      },
      cancel() {
        clearInterval(logoutIntervalTimer);
        this.dialog = false;
        this.samlPartialLogout();
      },
      setTime(seconds) {
        clearInterval(logoutIntervalTimer);
        this.timer(seconds);
      },
      timer(seconds) {
        const now = Date.now();
        const end = now + seconds * 1000;
        this.countdown(end);
      },
      countdown(end) {
        logoutIntervalTimer = setInterval(() => {
          const secondsLeft = Math.round((end - Date.now()) / 1000);

          if (secondsLeft < 0) {
            clearInterval(logoutIntervalTimer);
            this.dialog = false;
            this.samlSsoLogout();
            return;
          }
          this.displayTimeLeft(secondsLeft);
        }, 1000);
      },
      displayTimeLeft(secondsLeft) {
        const seconds = secondsLeft % 60;
        this.timeLeft = `${this.zeroPadded(seconds)}`;
      },
      zeroPadded(num) {
        return num < 10 ? `0${num}` : num;
      },
      samlPartialLogout() {
        let ssoLogoutUrl = `https://ssoaddonsext.test.det.nsw.edu.au/ssoaddon/logout`;
        if(location.hostname.match('test.education.nsw.gov.au')) {
          ssoLogoutUrl = `https://ssoaddonsext.test.det.nsw.edu.au/ssoaddon/logout`;
        } else if(location.hostname.match('pre.education.nsw.gov.au')) {
          ssoLogoutUrl = `https://ssoaddonsext.pre.det.nsw.edu.au/ssoaddon/logout`;
          console.log(ssoLogoutUrl);
        } else if(location.hostname.match('ictplus.education.nsw.gov.au')) {
          ssoLogoutUrl = `https://ssoaddonsext.det.nsw.edu.au/ssoaddon/logout`;
        }
        console.log(ssoLogoutUrl);
        //sessionStorage.removeItem('ictp-token');
        //sessionStorage.removeItem('ictp-splash-page-status');
        this.clearAllFilters();
        sessionStorage.clear();
        this.removeToken(this.$store.state);
        window.location = ssoLogoutUrl;
      },
      samlSsoLogout() {
        const schoolSiteCode = this.school.site_code? this.school.site_code : '*';
        this.$ga.event({
            eventCategory: 'App',
            eventAction: 'session timout logout',
            eventLabel: `sitecode:${schoolSiteCode}`
        });

        let ssoLogoutUrl = `https://sso.test.det.nsw.edu.au/sso/logout`;
        if(location.hostname.match('test.education.nsw.gov.au')) {
          ssoLogoutUrl = `https://sso.test.det.nsw.edu.au/sso/logout`;
        } else if(location.hostname.match('pre.education.nsw.gov.au')) {
          ssoLogoutUrl = `https://sso.pre.det.nsw.edu.au/sso/logout`;
        } else if(location.hostname.match('ictplus.education.nsw.gov.au')) {
          ssoLogoutUrl = `https://sso.det.nsw.edu.au/sso/logout`;
        }
        console.log(ssoLogoutUrl);
        window.location = ssoLogoutUrl;
      },
      ...mapActions(['refreshToken','removeToken','clearAllFilters']),
    }
  }
</script>
